import { Injectable } from '@angular/core';
import { ConfigurationService } from './configuration.service';
import { DataService } from './data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { IClaims } from '../../models/claims.model';
import { ISearchClaimVM } from '../../models/search-claim.model';
import { Observable } from 'rxjs';
import { SecurityService } from './security.service';

@Injectable()
export class AuthService {
  private authUrl: string = '/api/auth/'

  constructor(private service: DataService, private configurationService: ConfigurationService, private http: HttpClient, private securityService: SecurityService) {
    if (this.configurationService.isReady || this.configurationService.serverSettings != undefined)
      this.authUrl = this.configurationService.serverSettings.policyClaimsAgentUrl + this.authUrl;
    else
      this.configurationService.settingsLoaded$.subscribe(x => this.authUrl = this.configurationService.serverSettings.policyClaimsAgentUrl + this.authUrl);
  }


  checkClaimAccessiblity(claimId: number, organisationId: number): any {
    //let url = this.authUrl + 'isClaimAccessible? claimId=' + claimId + '& handlingOrganisationId= ' + organisationId
    let url = this.authUrl + 'isClaimAccessible';
    return this.service.get(url, { claimId: claimId , handlingOrganisationId: organisationId}).pipe<any>(tap((response: any) => {
      return response;
    }));
  }

  checkPolicyAccessiblity(PolicyId: number, organisationId: number): any {
    //let url = this.authUrl + 'isClaimAccessible? claimId=' + claimId + '& handlingOrganisationId= ' + organisationId
    let url = this.authUrl + 'isPolicyAccessible';
    return this.service.get(url, { policyId: PolicyId, handlingOrganisationId: organisationId }).pipe<any>(tap((response: any) => {
      return response;
    }));
  }
}
